require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./feature-ask-for-angela.json") })
        }
      }, "path---feature-ask-for-angela");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---feature-ask-for-angela!./.cache/json/feature-ask-for-angela.json
// module id = 634
// module chunks = 231608221292675